<template lang="pug">
v-dialog(v-model="dialogOpen", max-width="820", transition="dialog-transition")
  v-card.auth-dialog(v-if="dialogOpen")
    .auth-dialog__header
      .auth-dialog__icon
        v-icon(color="#6f78ff", size="28") mdi-qrcode
      .auth-dialog__heading
        .auth-dialog__title QRCode de autenticação do usuário CONTROL
        .auth-dialog__subtitle {{ trimestre }}

    v-divider

    .auth-dialog__body
      .auth-dialog__key-card(@click="copyKey")
        .auth-dialog__key-label Chave de autenticação
        .auth-dialog__key-row
          span.auth-dialog__key {{ key }}
          v-slide-x-transition
            v-icon.ml-2(v-if="showIcon", color="success", small) mdi-check-circle
            v-icon.ml-2(v-else, color="#8ea3bf", small) mdi-content-copy
        .auth-dialog__key-hint(v-if="!showIcon") Clique para copiar
        .auth-dialog__key-hint.auth-dialog__key-hint--copied(v-else) Chave copiada!

      .auth-dialog__qr-wrapper
        v-img.auth-dialog__qr(
          v-if="url",
          :src="url",
          alt="QR Code",
          width="280",
          height="280",
          contain
        )

    v-divider

    v-card-actions.auth-dialog__actions
      v-spacer
      v-btn(color="primary", text, @click="dialogOpen = false")
        v-icon(left, small) mdi-close
        span Fechar
</template>

<script>
const HASH_BASE = "NNNF2TZPJFEVKZDHIVSEIURJJNUDANCH";

export default {
  name: "AutenticacaoDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    trimestre: "",
    key: null,
    url: null,
    showIcon: false,
    copyIconTimeout: null
  }),
  computed: {
    dialogOpen: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  watch: {
    dialogOpen: {
      immediate: true,
      handler(open) {
        if (open) {
          this.computeKey();
        }
      }
    }
  },
  beforeDestroy() {
    if (this.copyIconTimeout) {
      clearTimeout(this.copyIconTimeout);
    }
  },
  methods: {
    computeKey() {
      const anoAtual = new Date().getFullYear();
      const mes = new Date().getMonth() + 1;
      const trimestre = Math.trunc((mes + 2) / 3);
      const anoMultiplicado = (anoAtual * trimestre).toString();

      let result = HASH_BASE;
      for (let i = 0; i < anoMultiplicado.length; i++) {
        result += String.fromCharCode(parseInt(anoMultiplicado[i], 10) + 65);
      }
      result += String.fromCharCode(trimestre + 65);

      this.trimestre = `${trimestre}º trimestre de ${anoAtual}`;
      this.key = result;
      this.url = `https://quickchart.io/chart?cht=qr&chs=500x500&chl=otpauth://totp/Senha%20ControlSoft%20-%20${anoAtual}/${trimestre}?secret=${result}`;
    },
    copyKey() {
      navigator.clipboard.writeText(this.key).then(() => {
        this.showIcon = true;
        if (this.copyIconTimeout) clearTimeout(this.copyIconTimeout);
        this.copyIconTimeout = setTimeout(() => {
          this.showIcon = false;
        }, 3000);
      });
    }
  }
};
</script>

<style scoped>
.auth-dialog {
  border-radius: 10px !important;
  overflow: hidden;
}

.auth-dialog__header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 24px;
  background: linear-gradient(135deg, #eef1ff 0%, #f7f8ff 100%);
}

.auth-dialog__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: rgba(111, 120, 255, 0.14);
  flex-shrink: 0;
}

.auth-dialog__heading {
  flex: 1 1 auto;
  min-width: 0;
}

.auth-dialog__title {
  color: #0f2b57;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
}

.auth-dialog__subtitle {
  color: #5b6f90;
  font-size: 13px;
  font-weight: 500;
  margin-top: 2px;
}

.auth-dialog__body {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 20px;
  align-items: center;
  padding: 24px;
}

.auth-dialog__key-card {
  padding: 16px 18px;
  border: 1px solid #d9e2ec;
  border-radius: 10px;
  background: #f7faff;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
  min-width: 0;
}

.auth-dialog__key-card:hover {
  border-color: #6f78ff;
  background: #eef1ff;
}

.auth-dialog__key-label {
  color: #8ea3bf;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.auth-dialog__key-row {
  display: flex;
  align-items: center;
  min-width: 0;
}

.auth-dialog__key {
  flex: 1 1 auto;
  min-width: 0;
  color: #0f2b57;
  font-family: "Consolas", "Monaco", monospace;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.5px;
  word-break: break-all;
  line-height: 1.35;
}

.auth-dialog__key-hint {
  margin-top: 8px;
  color: #8ea3bf;
  font-size: 12px;
  font-weight: 500;
}

.auth-dialog__key-hint--copied {
  color: #13c38b;
}

.auth-dialog__qr-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: 1px solid #d9e2ec;
  border-radius: 10px;
  background: #ffffff;
}

.auth-dialog__qr {
  border-radius: 10px;
}

.auth-dialog__actions {
  padding: 12px 20px !important;
}

@media (max-width: 640px) {
  .auth-dialog__body {
    grid-template-columns: 1fr;
  }

  .auth-dialog__qr-wrapper {
    justify-self: center;
  }
}
</style>
